export default __webpack_public_path__ + "static/Plots0060-8fa5d4ebc41f6bfcd4b0e1440b42c2e5.jpg";